const rootPattern = root => new RegExp('^' + root + '(\/|#|\\?|$)')

const rules = [
    { name: 'favorites', pattern: rootPattern('search/favorites') },
    { name: 'search', pattern: rootPattern('search') },
    { name: 'activity', pattern: rootPattern('activity') },
    { name: 'profile-edit', pattern: rootPattern('athlete_profile') },
    { name: 'messages', pattern: rootPattern('messages') },
    { name: 'verification-landing-page', pattern: rootPattern('account/schedule') },
    { name: 'upgrade-landing-page', pattern: rootPattern('pricing') },
    { name: 'account', pattern: rootPattern('account') },
    { name: 'profile', pattern: rootPattern('athlete') },
    { name: 'video', pattern: rootPattern('video') },
]

export default function (url) {
    const route = extractRoute(url)
    const first = rules.find(({ pattern }) => pattern.test(route))
    return first ? first.name : 'other'
}

function extractRoute(url) {
    return url.replace(/^https?:\/\/[^\/]+\/?/, '')
}